function initCustomSliders() {
  if (typeof jQuery === 'undefined' || typeof $.fn.slick === 'undefined') return;

 

  if($('.custom-slider').length > 0)
  {
    $('.custom-slider').each(function() {
        const $slider = $(this);
        if ($slider.hasClass('slick-initialized')) return;
        $slider.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        dots: false,
        infinite: false,
        arrows: true,
        prevArrow: `
            <button type="button" class="slick-prev custom-arrow">
            <svg width="30" height="53" viewBox="0 0 30 53" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(180deg);">
                <path d="M0 3.32625L2.955 0L30 26.25L2.955 52.5L0 49.1737L23.6175 26.25L0 3.32625Z" fill="#B4B4B4"/>
            </svg>
            </button>
        `,
        nextArrow: `
            <button type="button" class="slick-next custom-arrow">
            <svg width="30" height="53" viewBox="0 0 30 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 3.32625L2.955 0L30 26.25L2.955 52.5L0 49.1737L23.6175 26.25L0 3.32625Z" fill="#B4B4B4"/>
            </svg>
            </button>
        `,
        responsive: [
            { breakpoint: 1300, settings: { slidesToShow: 3 } },
            { breakpoint: 1112, settings: { slidesToShow: 2 } },
            { breakpoint: 768, settings: { slidesToShow: 1.8 } }
        ]
        });
    });
  } 

  if($('.custom-slider_2').length > 0)
  {
    $('.custom-slider_2').each(function() {
        const $slider_1 = $(this);
        if ($slider_1.hasClass('slick-initialized')) return;
        $slider_1.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        dots: false,
        infinite: false,
        arrows: true,
        prevArrow: `
            <button type="button" class="slick-prev custom-arrow">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(180deg);">
                <path d="M4.79993 1.95341L5.58793 1.06641L12.7999 8.06641L5.58793 15.0664L4.79993 14.1794L11.0979 8.06641L4.79993 1.95341Z" fill="black"/>
            </svg>
            </button>
        `,
        nextArrow: `
            <button type="button" class="slick-next custom-arrow">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.79993 1.95341L5.58793 1.06641L12.7999 8.06641L5.58793 15.0664L4.79993 14.1794L11.0979 8.06641L4.79993 1.95341Z" fill="black"/>
            </svg>
            </button>
        `,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                slidesToShow: 1,
                centerMode: true,
                centerPadding: '25%', 
                infinite: true,
                initialSlide: 1
                }
            }
            ]
        });
    });
  }
  
  if($('.custom-slider_3').length > 0)
  {
    $('.custom-slider_3').each(function() {
        const $slider_3 = $(this);
        if ($slider_3.hasClass('slick-initialized')) return;
        $slider_3.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            dots: true,
            arrows: false,
            autoplaySpeed: 5000,
            adaptiveHeight: true
        });
    });
  }
}

jQuery(document).ready(function() {

    initCustomSliders();


    var $section = $('.shop-the-look-elena');
    var $bottom = $section.find('.shop-the-look-elena__bottom');
    var $subimages = $section.find('.shop-the-look-elena__subimages');
    var $mainCol = $section.find('.shop-the-look-elena__main-img');
    var $textCol = $section.find('.shop-the-look-elena__col').not('.shop-the-look-elena__main-img');
    var $tabs_e = $(".tabs-elena__items");

    var moved = false;
    var slickInitialized = false;
    var slickInitialized_2 = false;

    function initSlider() {
        if (!slickInitialized && $subimages.length) {
        $subimages.slick({
            slidesToShow: 1.8,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: false,
            adaptiveHeight: true,
            prevArrow: `
                <button type="button" class="slick-prev custom-arrow">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(180deg);">
                    <path d="M4.79993 1.95341L5.58793 1.06641L12.7999 8.06641L5.58793 15.0664L4.79993 14.1794L11.0979 8.06641L4.79993 1.95341Z" fill="black"/>
                </svg>
                </button>
            `,
            nextArrow: `
                <button type="button" class="slick-next custom-arrow">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.79993 1.95341L5.58793 1.06641L12.7999 8.06641L5.58793 15.0664L4.79993 14.1794L11.0979 8.06641L4.79993 1.95341Z" fill="black"/>
                </svg>
                </button>
            `,
        });
        slickInitialized = true;
        }

        if(!slickInitialized_2 && $('.tabs-elena__items').length > 0)
        {
            $('.tabs-elena__items').each(function() {
                $(this).slick({
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: false,
                    infinite: false,
                    adaptiveHeight: true,
                    prevArrow: `
                        <button type="button" class="slick-prev custom-arrow">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(180deg);">
                            <path d="M4.79993 1.95341L5.58793 1.06641L12.7999 8.06641L5.58793 15.0664L4.79993 14.1794L11.0979 8.06641L4.79993 1.95341Z" fill="black"/>
                        </svg>
                        </button>
                    `,
                    nextArrow: `
                        <button type="button" class="slick-next custom-arrow">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.79993 1.95341L5.58793 1.06641L12.7999 8.06641L5.58793 15.0664L4.79993 14.1794L11.0979 8.06641L4.79993 1.95341Z" fill="black"/>
                        </svg>
                        </button>
                    `,
                });
            })

            slickInitialized_2 = true;
        }
    }

    function destroySlider() {
      if (slickInitialized && $subimages.hasClass('slick-initialized')) {
        $subimages.slick('unslick');
        slickInitialized = false;
      }
      if (slickInitialized_2 && $tabs_e.hasClass('slick-initialized')) {
        $tabs_e.slick('unslick');
        slickInitialized_2 = false;
      }
    }

  function handleResize() {
    var windowWidth = $(window).width();

    if (windowWidth < 768) {
      if (!moved) {
        $mainCol.append($bottom);
        moved = true;
      }
      initSlider();
    } else {
      if (moved) {
        $textCol.append($bottom);
        moved = false;
      }
      destroySlider();
    }
  }

    handleResize();
    $(window).on('resize', handleResize);



});